// Constants extracted from AssessmentModule.js

// Constants
export const NAME = "assessment";
export const SET_CURRENT_STEP = "SET_CURRENT_STEP" + " " + NAME;
export const UPDATE_ASSESSMENT_IN_REDUX =
  "UPDATE_ASSESSMENT_IN_REDUX" + " " + NAME;
export const UPDATE_FILTERS = "UPDATE_FILTERS" + " " + NAME;
export const INIT_FILTERS = "INIT_REPORT_FILTERS" + " " + NAME;
export const SAVE_FIELD_UPDATE_ACTIVITY_STATUS =
  "SAVE_FIELD_UPDATE_ACTIVITY_STATUS" + " " + NAME;
export const CLEAR_FIELD_UPDATE_ACTIVITY_STATUS =
  "CLEAR_FIELD_UPDATE_ACTIVITY_STATUS" + " " + NAME;
export const UPDATE_AI_DATA_IN_REDUX = "UPDATE_AI_DATA_IN_REDUX" + " " + NAME;
export const UPDATE_SHOW_AI_QUICK_TIP = "UPDATE_SHOW_AI_QUICK_TIP" + " " + NAME;
export const SET_AI_EVALUATION_EXPANDED_STATE =
  "SET_AI_EVALUATION_EXPANDED_STATE" + " " + NAME;
export const SET_LTI_ATTACHMENT_DELETED =
  "SET_LTI_ATTACHMENT_DELETED" + " " + NAME;
